import React, { useEffect } from "react";
import { NotificationAlertContext } from "../../contexts/notificationAlertContext.js";
import { useHistory, useParams } from "react-router-dom";

import { API, graphqlOperation } from "aws-amplify";
import SweetAlert from "react-bootstrap-sweetalert";
import _ from "lodash";

import {
  processChannelMessage,
  getS3DataForInboundMessages,
} from "../../graphql/queries.js";
// react-bootstrap components
import {
  Container,
  Card,
  Row,
  Col,
  Table,
  OverlayTrigger,
  Tooltip,
  Button,
  Spinner,
} from "react-bootstrap";

import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import Chat from "views/Components/Chat.js";
import { tourGuideSteps } from "views/Components/ViewMessageSteps.js";
import { AuthContext } from "contexts/authContext.js";
import { useTour } from "@reactour/tour";

const ViewMessage = (props) => {
  // Contexts
  const notify = React.useContext(NotificationAlertContext);
  const currentUser = React.useContext(AuthContext);
  const history = useHistory();

  const searchParams = new URLSearchParams(window.location.search);

  const clientEnvironmentId = searchParams.get("clientEnvironmentId");
  const channelId = searchParams.get("channelId");
  const messageId = searchParams.get("messageId");
  const messageDataAvailable = searchParams.get("messageDataAvailable");

  // Tour Guide
  const { setIsOpen, setCurrentStep, setSteps } = useTour();

  // SSO related information
  let { batchId, inboundMessageIdempotencyKey } = useParams();

  inboundMessageIdempotencyKey = inboundMessageIdempotencyKey.split("?")[0];
  const clientId = props.location.state?.clientId;

  const [clientName, setClientName] = React.useState("");
  const [clientEnvironmentName, setClientEnvironmentName] = React.useState("");
  const [channelName, setChannelName] = React.useState("");
  const [messageDetails, setMessageDetails] = React.useState({
    msgContentB64: "",
    msgDate: "",
    messageId: "",
    sizeInBytes: "",
    connectorData: "",
    inboundMessageIdempotencyKey: "",
  });

  const [isDescriptionEditable, setIsDescriptionEditable] =
    React.useState(false);
  const [showLoader, setShowLoader] = React.useState(false);
  const [description, setDescription] = React.useState("");
  const [errorMessage, setErrorMessage] = React.useState("");
  const [viewChatModal, setViewChatModal] = React.useState(false);
  const [initialPrompt, setInitialPrompt] = React.useState("");
  const [largeMessage, setLargeMessage] = React.useState(false);

  let redirectUrl = "";
  if (batchId) {
    redirectUrl = "/admin/message-batches";
  } else {
    redirectUrl = "/admin/find-or-reprocess";
  }

  const zindex = {
    zIndex: "9999",
  };
  const sweetAlertCustom = {
    display: "block",
    marginTop: "-100px",
    fontSize: "14px",
    overflow: "auto",
    textAlign: "left",
    width: "80%",
  };
  const descriptionButtonsStyle = {
    margin: "5px",
    float: "right",
  };

  const descriptionStyle = {
    minWidth: "100%",
    minHeight: "200px",
  };

  const descriptionStyleWithNoMessage = {
    minWidth: "100%",
    minHeight: "200px",
    textAlign: "center",
    paddingTop: "5%",
  };
  const ellipsisStyle = {
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    width: "300px",
  };
  const noMargin = {
    margin: 0,
  };
  const CONNECTOR_TIMER = 10000;

  function isLessThan1MB(text) {
    const byteSize = new Blob([text]).size;
    const oneMB = 1024 * 1024; // 1 MB = 1048576 bytes
    return byteSize < oneMB;
  }
  const processMessage = async (
    clientEnvironmentId,
    channelId,
    channelName,
    message_id,
    idempotency_key,
    message_data
  ) => {
    try {
      if (!isLessThan1MB(message_data)) {
        notify("danger", "Message is greater then 1 MB");
        return;
      }
      notify("info");
      let payload;
      if (message_data === messageDetails.msgContentB64 || largeMessage) {
        payload = {
          client_environment_id: clientEnvironmentId,
          channel_id: channelId,
          idempotency_key: idempotency_key,
        };
      } else {
        payload = {
          client_environment_id: clientEnvironmentId,
          channel_id: channelId,
          message_data: message_data,
        };
      }
      const response = await API.graphql(
        graphqlOperation(processChannelMessage, payload)
      );
      if (response.data?.processChannelMessage?.success) {
        notify(
          "success",
          `Successfully reprocessed Original Message ID ${message_id} for ${channelName}. It's New Message ID is ${response.data.processChannelMessage.body?.response}.`,
          -1
        );
      } else {
        console.error(response.data?.processChannelMessage?.message);
        notify(
          "danger",
          `Error reprocessing Message ID ${message_id} for ${channelName}.`,
          -1
        );
      }
      return response.data?.processChannelMessage?.success;
    } catch (error) {
      console.error(error);
      notify(
        "danger",
        `Error reprocessing Message ID ${message_id} for ${channelName}.`,
        -1
      );
      return false;
    }
  };

  const fetchS3DataForInboundMessages = async (messageId, query) => {
    try {
      setShowLoader(true);
      const response = await API.graphql(
        graphqlOperation(getS3DataForInboundMessages, query)
      );
      if (response.data?.getS3DataForInboundMessages?.success) {
        const s3ResponseString = _.get(
          response,
          "data.getS3DataForInboundMessages.body.s3_data"
        );
        const keyValuePairs = s3ResponseString.slice(1, -1).split(", ");

        const data = {};
        keyValuePairs.forEach((pair) => {
          const [key, value] = pair.split(/=(.+)/);
          data[key] = isNaN(value) ? value : parseFloat(value) || value;
        });
        const connectorData = _.get(
          response,
          "data.getS3DataForInboundMessages.body.connector_data"
        );
        const searchTokenData = _.get(
          response,
          "data.getS3DataForInboundMessages.body.search_token_data"
        );
        const channelData = _.get(
          response,
          "data.getS3DataForInboundMessages.body.channel_data"
        );
        connectorData.map((x) => {
          if (x.connector_msg_status === "ERROR") {
            setErrorMessage(x.connector_msg_status);
            return;
          }
        });

        setClientName(channelData?.client_name);
        setClientEnvironmentName(channelData?.client_environment_name);
        setChannelName(channelData?.channel_name);
        setMessageDetails({
          ...data,
          connectorData,
          searchTokenData,
          messageId,
          inboundMessageIdempotencyKey: query.inboundMessageIdempotencyKey,
        });
        const largeMessage = data.containsRawMessage !== "true";
        setLargeMessage(largeMessage);

        const msgContentB64 =
          data.msgContentB64 === "null" ? null : data.msgContentB64;

        const description = msgContentB64
          ? atob(msgContentB64)
          : largeMessage
            ? "This message is too large to display. You can reprocess the original message by clicking the Reprocess Message button below."
            : "";

        setDescription(description);

        notify("success");
      } else {
        console.error(response.data?.getS3DataForInboundMessages?.message);
        notify("danger");
        history.goBack();
      }
    } catch (error) {
      console.error(error);
      notify("danger");
      history.goBack();
    } finally {
      setShowLoader(false);
    }
  };

  const callS3url = async (parameters) => {
    try {
      const jsonPacket = {
        inboundMessageIdempotencyKey: inboundMessageIdempotencyKey,
        clientEnvironmentId,
        channelId,
        messageId: parameters.messageId,
      };
      if (parameters.messageDataAvailable) {
        await fetchS3DataForInboundMessages(parameters.messageId, jsonPacket);
        return true;
      } else {
        setAlert(
          <SweetAlert
            warning
            showCancel
            style={sweetAlertCustom}
            title="Not Existing"
            confirmBtnBsStyle="primary"
            confirmBtnText="Ok"
            onConfirm={() => hideAlert()}
            onCancel={() => hideAlert()}
            focusCancelBtn
          >
            <h2>Message too large to display</h2>
          </SweetAlert>
        );
        history.goBack();
        return false;
      }
    } catch (error) {
      history.push(redirectUrl);
      console.error(error);
      return false;
    } finally {
      setShowLoader(false);
    }
  };

  useEffect(() => {
    async function fetchData() {
      setShowLoader(true);
      const parameters = {
        messageId: messageId,
        messageDataAvailable: messageDataAvailable,
      };
      const isSuccess = await callS3url(parameters);
      if (!isSuccess) {
        notify("danger");
        history.goBack();
      }
    }
    fetchData();
  }, []);

  const [alert, setAlert] = React.useState(null);

  const hideAlert = () => {
    setAlert(null);
  };

  if (showLoader) return <Spinner animation="grow" />;
  return (
    <>
      {alert}
      <Container fluid>
        <Row>
          <Col>
            <h2>Message Details</h2>
          </Col>
          {currentUser.groupName === "external" && (
            <Col className="my-auto text-right">
              <Button
                variant="secondary"
                className="btn-outline"
                onClick={() => {
                  setSteps(tourGuideSteps);
                  setCurrentStep(0);
                  setIsOpen(true);
                }}
              >
                <i className="fas fa-desktop"></i> View Our Tour Guide
              </Button>
            </Col>
          )}
        </Row>
        <Card id="client-details-card">
          <Card.Body>
            <Row>
              <Col md="12">
                <h3>Client Details</h3>
                <p style={noMargin}>Client Name: {clientName}</p>
                <p style={noMargin}>
                  Environment Name: {clientEnvironmentName}
                </p>
                <p style={noMargin}>Channel Name: {channelName}</p>
                <p style={noMargin}>
                  Message Date:{" "}
                  {new Date(messageDetails.msgDate).toLocaleString()}
                </p>
                <p style={noMargin}>Message Id: {messageDetails.messageId}</p>
                <p style={noMargin}>
                  Size In Bytes: {messageDetails.sizeInBytes}
                </p>
              </Col>
            </Row>
          </Card.Body>
        </Card>
        <Card id="search-token-details-card">
          <Card.Body>
            <Row>
              <Col md="12">
                <h3>Search Token Details</h3>
                {messageDetails.connectorData &&
                  messageDetails.connectorData.length > 0 && (
                    <>
                      <Table className="table-hover table-striped w-full">
                        <thead>
                          <tr>
                            <th>Search Token Key</th>
                            <th>Search Token Value</th>
                          </tr>
                        </thead>
                        <tbody>
                          {messageDetails.searchTokenData.map(
                            (tokenData, key) => {
                              return (
                                <tr key={key}>
                                  <td>{tokenData.search_token_key}</td>
                                  <td>{tokenData.search_token_value}</td>
                                </tr>
                              );
                            }
                          )}
                        </tbody>
                      </Table>
                    </>
                  )}
              </Col>
            </Row>
          </Card.Body>
        </Card>
        <Card>
          <Card.Body>
            <Row>
              <Col md="12" id="connector-details">
                <h3>Connector Details</h3>
                {messageDetails.connectorData &&
                  messageDetails.connectorData.length > 0 && (
                    <>
                      <Table className="table-hover table-striped w-full">
                        <thead>
                          <tr>
                            <th>Connector ID</th>
                            <th>Connector Name</th>
                            <th>Connector Message Status</th>
                            <th>Connector Error Text</th>
                            {errorMessage && <th></th>}
                            <th>Connector Date Processed</th>
                            <th>Process Time (sec)</th>
                          </tr>
                        </thead>
                        <tbody>
                          {messageDetails.connectorData.map(
                            (connector, key) => {
                              return (
                                <tr key={key}>
                                  <td>{connector.connector_id}</td>
                                  <td>{connector.connector_name}</td>
                                  <td>{connector.connector_msg_status}</td>
                                  <td>
                                    {
                                      <OverlayTrigger
                                        key={`event-type-${connector.connector_id}`}
                                        placement="right"
                                        overlay={
                                          <Tooltip
                                            id={`event-type-tooltip-${connector.connector_id}`}
                                            style={zindex}
                                          >
                                            {connector.connector_error_text}
                                          </Tooltip>
                                        }
                                      >
                                        <div style={ellipsisStyle}>
                                          {connector.connector_error_text
                                            ? connector.connector_error_text
                                            : ""}
                                        </div>
                                      </OverlayTrigger>
                                    }
                                  </td>
                                  {errorMessage && (
                                    <td>
                                      {connector.connector_msg_status ===
                                        "ERROR" && (
                                          <Button
                                            variant="primary"
                                            className="btn-outline"
                                            onClick={() => {
                                              setInitialPrompt(
                                                `Can you help me fix this Mirth Connect channel error?\n${connector.connector_error_text}`
                                              );
                                              setViewChatModal(true);
                                            }}
                                          >
                                            Mirth Assist
                                          </Button>
                                        )}
                                    </td>
                                  )}
                                  <td>
                                    {new Date(
                                      connector.connector_date_processed
                                    ).toLocaleString()}
                                  </td>
                                  <td>
                                    {Math.round(
                                      CONNECTOR_TIMER *
                                      connector.process_time_sec
                                    ) / CONNECTOR_TIMER}
                                  </td>
                                </tr>
                              );
                            }
                          )}
                        </tbody>
                      </Table>
                    </>
                  )}
              </Col>
            </Row>
            <Row>
              <Col id="discard-edit-buttons">
                <textarea
                  id="messageDescription"
                  style={
                    largeMessage
                      ? descriptionStyleWithNoMessage
                      : descriptionStyle
                  }
                  disabled={!isDescriptionEditable}
                  className="form-control"
                  value={description}
                  onChange={(event) => setDescription(event.target.value)}
                ></textarea>
              </Col>
            </Row>
            <Row>
              <Col>
                <div style={{ float: "right", marginTop: "10px" }}>
                  <Button
                    variant="primary"
                    className="btn-simple"
                    disabled={!isDescriptionEditable}
                    onClick={() => {
                      setDescription(atob(messageDetails.msgContentB64));
                      setIsDescriptionEditable(false);
                    }}
                  >
                    Discard
                  </Button>
                  <Button
                    variant="primary"
                    className="btn-simple"
                    disabled={largeMessage || isDescriptionEditable}
                    title={largeMessage ? "Message too large to edit" : ""}
                    onClick={() => setIsDescriptionEditable(true)}
                  >
                    Edit
                  </Button>
                  <Button
                    id="reprocess-message-button"
                    className="btn-outline"
                    variant="primary"
                    style={{ marginLeft: "30px" }}
                    onClick={() => {
                      processMessage(
                        clientEnvironmentId,
                        channelId,
                        channelName,
                        messageDetails.messageId,
                        messageDetails.inboundMessageIdempotencyKey,
                        btoa(description)
                      );
                    }}
                  >
                    <i className="fas fa-redo-alt"></i> Reprocess Message
                  </Button>
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>
        <Modal
          toggle={() => setViewChatModal(!viewChatModal)}
          size="xl"
          isOpen={viewChatModal}
          scrollable={true}
        >
          <ModalHeader style={{ justifyContent: "center" }}>
            Mirth Assist
          </ModalHeader>
          <ModalBody>
            <Chat
              clientId={clientId}
              clientEnvironmentId={clientEnvironmentId}
              channelId={channelId}
              inboundMessageIdempotencyKey={
                messageDetails.inboundMessageIdempotencyKey
              }
              initialPrompt={initialPrompt}
            />
          </ModalBody>
          <ModalFooter style={{ justifyContent: "center" }}>
            <Button
              variant="secondary"
              style={{ marginRight: "10px" }}
              onClick={() => {
                setViewChatModal(false);
              }}
            >
              Cancel
            </Button>
          </ModalFooter>
        </Modal>
      </Container>
    </>
  );
};

export default ViewMessage;
